import { css, Global } from '@emotion/react'

const RESET_TOUCH_STYLE = css`
	user-select: none;
	-webkit-touch-callout: none;
	-webkit-tap-highlight-color: transparent;
`

export default function GlobalStyles() {
	return (
		<Global
			styles={css`
				* {
					box-sizing: border-box;
					-webkit-tap-highlight-color: transparent;
				}

				:root,
				html {
					padding-left: calc(100vw - 100%);
					letter-spacing: 0.25px;
					color: var(--tint-primary);
					font-family: 'Source Han Sans VF', 'Noto Color Emoji', system-ui, sans-serif;
					line-height: normal;

					--page-container-width: 600px;
					--modal-container-width: 600px;
				}

				body {
					margin: 0;

					-webkit-font-smoothing: antialiased;
					-moz-osx-font-smoothing: grayscale;
					background-color: var(--bg-body-1);
					color: var(--tint-primary);
				}

				:focus-visible {
					outline-color: transparent;
				}

				a {
					-webkit-tap-highlight-color: transparent;
					&:any-link {
						text-decoration: none;
						color: inherit;
					}
				}

				img {
					user-select: none;
					-webkit-user-drag: none;
				}

				[data-clickable-feedback='true'] {
					cursor: pointer;
				}

				.hover-underline {
					position: relative;

					&::after {
						content: '';
						position: absolute;
						left: 0;
						bottom: 0;
						z-index: 0;
						height: 1.5px;
						width: 100%;
						background-color: currentcolor;
						transform: scaleX(0);
						transform-origin: left;
						transition: transform 0.2s ease-out;
					}

					&:hover {
						cursor: pointer;

						&::after {
							transform: scaleX(1);
						}
					}
				}

				.jk-link-text {
					text-decoration: none;
					width: fit-content;
					position: relative;

					&:not([aria-readonly='true']) {
						&::after {
							content: '';
							position: absolute;
							left: 0;
							bottom: 0;
							z-index: 0;
							height: 1.5px;
							width: 100%;
							background-color: currentcolor;
							transform: scaleX(0);
							transform-origin: left;
							transition: transform 0.2s ease-out;
						}

						&:hover::after {
							transform: scaleX(1);
						}
					}
				}
			`}
		/>
	)
}
